export default __webpack_public_path__ + "static/media/bnr1.405f8fc3.jpg";